import { render, staticRenderFns } from "./LiveBroadcast.vue?vue&type=template&id=44645a24&scoped=true&"
import script from "./LiveBroadcast.vue?vue&type=script&lang=js&"
export * from "./LiveBroadcast.vue?vue&type=script&lang=js&"
import style0 from "./LiveBroadcast.vue?vue&type=style&index=0&id=44645a24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44645a24",
  null
  
)

export default component.exports